<template>
    <div class="strategy">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="strategy__text-wrapper">
                        <TitleDescription
                            title="Roll out the game-changing marketing strategy for your ecommerce with CrossProm" 
                        />
                    </div>
                    <div class="strategy__items">
                        <StrategyItem
                            v-for="(item,index) in strategyData"
                            :key="`${item.icon}-${index}`"
                            :data="item"
                        />
                    </div>
                    <div class="d-flex justify-content-center">
                        <Button 
                            @click.native="$store.commit('TOGGLE_MODAL', ['sign-up', {
                                openedFrom: 'Join Now for Free Bottom'
                            }])"
                            class="strategy__button" 
                            type="primary"
                        >
                            Join Now for Free
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TitleDescription from '@/components/Ecommerce/TitleDescription'
import Icon from '@/components/Theme/Icon'
import Button from '@/components/Theme/Button'
import StrategyItem from './StrategyItem'
import { strategyData } from './strategyData'
export default {
    name: 'Strategy',
    components: {
        Icon,
        StrategyItem,
        Button,
        TitleDescription
    },
    data() {
        return {
            strategyData
        }
    }
}
</script>

<style lang="scss" scoped>
$background: #00002D;
$strategy_top_gap: 100px;
$strategy_top_gap_mob: 69px;
$strategy_top_sm_gap: 48px;
$strategy_bottom_gap: 88px;
$strategy_bottom_gap_mob: 56px;
$strategy_bottom_sm_gap: 38px;
$text-wrapper-width: 560px;
$strategy_items_top_gap: 36px;
$strategy_items_bottom_gap: 48px;
$strategy_items_top_sm_gap: 20px;
$strategy_items_bottom_sm_gap: 24px;
$strategy_items_top_gap_mob: 20px;
$strategy_items_bottom_gap_mob: 24px;
$join_now_button_width: 248px;
$join_now_button_fontsize: 16px;
$join_now_button_height: 48px;
$font: 'Eina SemiBold';
.strategy {
    --title-fontsize: 20px;
    --title-lineheight: 28px;
    --title-margin-bottom: 0;

    --title-color: #ffffff;

    @media (max-width: 576px) {
        --title-fontsize: 16px;
        --title-lineheight: 24px;
    }

    background: $background;
    padding-top: $strategy_top_gap;
    padding-bottom: $strategy_bottom_gap;
    @media (max-width: 767px) {
        padding-top: $strategy_top_gap_mob;
        padding-bottom: $strategy_bottom_gap_mob;
    }
    @media (max-width: 576px) {
        padding-top: $strategy_top_sm_gap;
        padding-bottom: $strategy_bottom_sm_gap;
    }

    &__text-wrapper {
        max-width: 560px;
        margin: 0 auto;
        text-align: center;
    }
    &__items {
        display: flex;
        align-items: stretch;
        justify-content: center;
        padding-top: $strategy_items_top_gap;
        padding-bottom: $strategy_items_bottom_gap;
        @media (max-width: 767px) {
            padding-top: $strategy_items_top_gap_mob;
            padding-bottom: $strategy_items_bottom_gap_mob;
            align-items: center;
            flex-direction: column;
            justify-content: center;        
        }
        @media (max-width: 576px) {
            padding-top: $strategy_items_top_sm_gap;
            padding-bottom: $strategy_items_bottom_sm_gap;
        }
    }
    &__button {
        width: 100%;
        height: $join_now_button_height;
        max-width: $join_now_button_width;
        font-family: $font;
        font-size: $join_now_button_fontsize;
    }
}
</style>>
